import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from 'formik';
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../Config";
import { useDispatch, useSelector } from "react-redux";
import { getQuoteCompGenInfo } from "../../Redux/action/Sales/QuoteAirExportCompGenInfoAction";
import { capitalizeFirstLetter, DDMMMYYYYformateDate } from "../../HelperFunctions";
import { getCustomerQuoteDetail } from "../../Redux/action/Admin/CustomerAction";

const CustomerQueryInformation = ({ showSideNavBar }) => {
    // console.log(accessedPermission);
    const dispatch = useDispatch();
    const [quotationId, setQuotationId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(true);
    const [viewData, setViewData] = useState([]);
    const [show, setShow] = useState(false);
    const [showPageLoader, setShowPageLoader] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showRemark, setShowRemark] = useState(false);
    const handleCloseRemark = () => setShowRemark(false);
    const handleShowRemark = () => setShowRemark(true);
    const [additionalsArray, setAdditionalArray] = useState([]);
    const [showPricing, setShowPricing] = useState(false);
    const handleClosePricing = () => setShowPricing(false);
    const handleShowPricing = () => setShowPricing(true);
    const [originType, setOriginType] = useState("");
    const [destinationType, setDestinationType] = useState("");
    const [shipmentMode, setShipmentMode] = useState("air");
    const [message_id, setMessage_id] = useState("");

    const location = useLocation();
    const { b64id } = useParams();

    const token = Cookies.get("customertoken");
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    let id = atob(b64id);

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                setQuotationId(id);
                dispatch(getCustomerQuoteDetail(token, id));

            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }
    }, [b64id]);

    let { loadingCustomerQuoteDetail,
        CustomerQuoteDetailDataError,
        CustomerQuoteDetailData } = useSelector(state => state?.CustomerReducer);



    const [ship_quotation_no, setShip_quotation_no] = useState("");
    const [ship_date_of_creation, setShip_date_of_creation] = useState("");
    const [ship_buy_ref_no, setShip_buy_ref_no] = useState("");
    const [ship_rate_validity, setShip_rate_validity] = useState("");
    const [ship_validity_against, setShip_validity_against] = useState("");
    const [ship_quotation_rise_in, setShip_quotation_rise_in] = useState("");


    const [com_company_name, setCom_company_name] = useState("");
    const [com_address, setCom_address] = useState("");
    const [com_phone_no, setCom_phone_no] = useState("");
    const [com_email, setCom_email] = useState("");
    const [com_gstin, setCom_gstin] = useState("");
    const [com_country_id, setCom_country_id] = useState("");
    const [com_state_id, setCom_state_id] = useState("");

    const [gen_customer_name, setGen_customer_name] = useState("");
    const [gen_address, setGen_address] = useState("");
    const [gen_billing_account, setGen_billing_account] = useState("");
    const [gen_attention_to, setGen_attention_to] = useState("");
    const [gen_airline, setGen_airline] = useState("");
    const [gen_place_of_receipt, setGen_place_of_receipt] = useState("");
    const [gen_commodity, setGen_commodity] = useState("");
    const [gen_airport_of_landing, setGen_airport_of_landing] = useState("");
    const [gen_cargo_weight, setGen_cargo_weight] = useState("");
    const [gen_cargo_weight_unit, setGen_cargo_weight_unit] = useState("");
    const [gen_airport_of_discharge, setGen_airport_of_discharge] = useState("");
    const [gen_incoterms, setGen_incoterms] = useState("");
    const [gen_tentative_transit_time, setGen_tentative_transit_time] = useState("");
    const [gen_find_place_of_delivery, setGen_find_place_of_delivery] = useState("");
    const [gen_notes, setGen_notes] = useState("");
    const [quote_tarrif, setQuote_tarrif] = useState([]);
    const [formatted_quote_tarrif, setFormatted_quote_tarrif] = useState([]);
    const [Id, setId] = useState(null);
    const [editableSellingPrice, setEditableSellingPrice] = useState("");


    const formik = useFormik({
        initialValues: {},
    })


    useEffect(() => {
        if (loadingCustomerQuoteDetail) {
            setSpinnerLoader(true);
        } else {
            setSpinnerLoader(false);
        }

        if (CustomerQuoteDetailData) {

            if (CustomerQuoteDetailData?.additional_info) {
                setAdditionalArray(CustomerQuoteDetailData?.additional_info)
            }

            if (CustomerQuoteDetailData?.shipment_mode) {
                if (CustomerQuoteDetailData?.shipment_mode == "air" || CustomerQuoteDetailData?.shipment_mode == "ocean") { setShipmentMode(CustomerQuoteDetailData?.shipment_mode) }
            }

            if (CustomerQuoteDetailData?.mail_message_id) {
                setMessage_id(CustomerQuoteDetailData?.mail_message_id);
            }


            if (CustomerQuoteDetailData?.shipment_mode == "courier") {
                setOriginType("");
                setDestinationType("")
            }
            if (CustomerQuoteDetailData?.shipment_mode == "air") {
                setOriginType(`(${CustomerQuoteDetailData?.origin_type})`);
                setDestinationType(`(${CustomerQuoteDetailData?.destination_type})`);
            } else if (CustomerQuoteDetailData?.shipment_mode == "ocean") {
                if (CustomerQuoteDetailData?.origin_type == "AIRPORT") {
                    setOriginType(`(SEAPORT)`)
                } else {
                    setOriginType(`(${CustomerQuoteDetailData?.origin_type})`);
                }

                if (CustomerQuoteDetailData?.destination_type == "AIRPORT") {
                    setDestinationType(`(SEAPORT)`)
                } else {
                    setDestinationType(`(${CustomerQuoteDetailData?.destination_type})`);
                }

            }


            if (CustomerQuoteDetailData?.quotationData) {
                setShip_quotation_no(CustomerQuoteDetailData?.quotationData?.ship_quotation_no)
                setShip_date_of_creation(CustomerQuoteDetailData?.quotationData?.ship_date_of_creation)
                setShip_buy_ref_no(CustomerQuoteDetailData?.quotationData?.ship_buy_ref_no);
                setShip_validity_against(CustomerQuoteDetailData?.quotationData?.currency_data ? `${CustomerQuoteDetailData?.quotationData?.currency_data?.currency} (${CustomerQuoteDetailData?.quotationData?.currency_data?.currency_symbol})` : "");
                setShip_rate_validity(CustomerQuoteDetailData?.quotationData?.ship_rate_validity);
                setShip_quotation_rise_in(CustomerQuoteDetailData?.quotationData?.ship_quotation_rise_in);

                setCom_company_name(CustomerQuoteDetailData?.quotationData?.com_company_name)
                setCom_address(CustomerQuoteDetailData?.quotationData?.com_address)
                setCom_phone_no(CustomerQuoteDetailData?.quotationData?.com_phone_no)
                setCom_email(CustomerQuoteDetailData?.quotationData?.com_email)
                setCom_gstin(CustomerQuoteDetailData?.quotationData?.com_gstin)
                setCom_country_id(CustomerQuoteDetailData?.quotationData?.country_data?.name)
                setCom_state_id(CustomerQuoteDetailData?.quotationData?.state_data?.name)

                setGen_customer_name(CustomerQuoteDetailData?.quotationData?.gen_customer_name)
                setGen_address(CustomerQuoteDetailData?.quotationData?.gen_address)
                setGen_billing_account(CustomerQuoteDetailData?.quotationData?.gen_billing_account)
                setGen_attention_to(CustomerQuoteDetailData?.quotationData?.gen_attention_to)
                setGen_airline(CustomerQuoteDetailData?.quotationData?.gen_airline)
                setGen_place_of_receipt(CustomerQuoteDetailData?.quotationData?.gen_place_of_receipt)
                setGen_commodity(CustomerQuoteDetailData?.quotationData?.gen_commodity)
                setGen_airport_of_landing(CustomerQuoteDetailData?.quotationData?.gen_airport_of_landing)
                setGen_cargo_weight(CustomerQuoteDetailData?.quotationData?.gen_cargo_weight);
                setGen_cargo_weight_unit(CustomerQuoteDetailData?.quotationData?.gen_cargo_weight_unit);
                setGen_airport_of_discharge(CustomerQuoteDetailData?.quotationData?.gen_airport_of_discharge)
                setGen_incoterms(CustomerQuoteDetailData?.quotationData?.incoterm ? CustomerQuoteDetailData?.quotationData?.incoterm?.name : "")
                setGen_tentative_transit_time(CustomerQuoteDetailData?.quotationData?.gen_tentative_transit_time)
                setGen_find_place_of_delivery(CustomerQuoteDetailData?.quotationData?.gen_find_place_of_delivery)
                setGen_notes(CustomerQuoteDetailData?.quotationData?.gen_notes);
                setQuote_tarrif(CustomerQuoteDetailData?.quotationData?.quote_tarrif);
            }
        }
    }, [loadingCustomerQuoteDetail, CustomerQuoteDetailDataError, CustomerQuoteDetailData]);

    useEffect(() => {
        if (quote_tarrif) {
            const groupedData = Object.values(
                quote_tarrif.reduce((acc, obj) => {
                    // Check if the airline_code group exists, if not, create an empty array
                    if (!acc[obj.airline_code]) {
                        acc[obj.airline_code] = [];
                    }
                    // Push the object into the appropriate group
                    acc[obj.airline_code].push(obj);
                    return acc;
                }, {})
            );

            setFormatted_quote_tarrif(groupedData);
        }
    }, [quote_tarrif])


    const navigate = useNavigate();

    const openNewWindow = (url) => {
        const newWindow = window.open(
            url, // URL of the new window
            '_blank', // Target window name
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
        );

        const interval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(interval);
                refresh();
            }
        }, 500);
    };



    const sendMessageToParent = () => {
        // Check if the opener window exists
        if (window.opener) {
            // Send a message to the parent window
            window.opener.postMessage('refreshQueryTableData', '*');
        }
    };

    const { loadingQuoteCompGenInfoApi, quoteCompGenInfoDataError, quoteCompGenInfoData } = useSelector(state => state?.QuoteAirExportCompGenInfoReducer);

    useEffect(() => {
        if (loadingQuoteCompGenInfoApi) {
            setShowPageLoader(true)
        } else {
            setShowPageLoader(false)
        }

    }, [loadingQuoteCompGenInfoApi, quoteCompGenInfoDataError, quoteCompGenInfoData]);



    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    const refresh = () => {
        dispatch(getCustomerQuoteDetail(token, id));
    }

    return (
        <div className={showSideNavBar ? "page-wrapper" : ""}>
            <div className={showSideNavBar ? "content" : 'content m-3'}>
                <div className="row">
                    <div className="col-md-12">
                    </div>
                </div>
                {
                    spinnerLoader ?
                        <div
                            className="d-flex justify-content-center align-items-center new_infometion_table"
                            style={{ height: "400px", width: "100%" }}
                        >
                            <BeatLoader />
                        </div> :
                        <div className="row">
                            <div className="col-md-12">
                                <div className="contact-head">
                                    <div className="row align-items-center mb-3 ">
                                        <div className="col-sm-6">
                                            <ul className="contact-breadcrumb">
                                                <li className="mb-0">
                                                    <h4 className="page-title">
                                                        View Query Information
                                                    </h4>
                                                </li>

                                            </ul>
                                        </div>
                                        {/* <div className="col-md-6">
                                            {
                                                CustomerQuoteDetailData?.quote_status?.name === "Price Received" ?
                                                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                        <div className="">
                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                priceView(quotationId)
                                                            }}>
                                                                View Rates
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    CustomerQuoteDetailData?.quote_status?.name === "Converted" ?
                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                            <div className="">
                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => { navigate(-1) }}>
                                                                    Follow-Up
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        CustomerQuoteDetailData?.quote_status?.name === "Repricing" ?
                                                            <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                <div className="">
                                                                    <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                        openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                    }}>
                                                                        View Rates
                                                                    </div>
                                                                </div>
                                                            </div> :
                                                            CustomerQuoteDetailData?.quote_status?.name === "Not Converted" ?
                                                                <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                    <div className="">
                                                                        <div className="send_query_list_button send-query btn btn-danger" onClick={() => { navigate(-1) }}>
                                                                            Follow-Up
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                CustomerQuoteDetailData?.quote_status?.name === "Price Viewed" ?
                                                                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                        <div className="">
                                                                            <button className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                // sendPricing(CustomerQuoteDetailData?.id)
                                                                                // navigate("/flexichain/all-rate-request", { state: { quotationId: quotationId } });
                                                                                handleShowRepricing();
                                                                            }}>
                                                                                Repricing
                                                                            </button>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {

                                                                                sentQuotation(CustomerQuoteDetailData?.id)
                                                                            }}>
                                                                                Send to Client
                                                                            </div>
                                                                        </div>
                                                                        <div className="">
                                                                            <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                // navigate(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                                // window.open(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                                openNewWindow(`/flexichain/export-view-rates-${shipmentMode}/${btoa(quotationId)}`)
                                                                            }}>
                                                                                View Rates
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    CustomerQuoteDetailData?.quote_status?.name === "Quotation Sent" ?
                                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                            <div className="contacts-action">
                                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    ConvertedType(CustomerQuoteDetailData?.id)
                                                                                }}>
                                                                                    Convert
                                                                                </div>
                                                                            </div>
                                                                            <div className="contacts-action">
                                                                                <div className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    NotConverted(CustomerQuoteDetailData?.id)
                                                                                }}>
                                                                                    Not Convert
                                                                                </div>
                                                                            </div>
                                                                            <div className="">
                                                                                <button className="send_query_list_button send-query btn btn-danger" onClick={() => {
                                                                                    handleShowRepricing();
                                                                                }}>
                                                                                    Repricing
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                                            <div className=" contacts-action">
                                                                                <div
                                                                                    className="send_query_list_button send-query btn btn-danger"
                                                                                    onClick={() => { navigate(`/flexichain/quote-form/edit/${btoa(quotationId)}`) }}
                                                                                >
                                                                                    Edit
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                CustomerQuoteDetailData?.last_status_id !== 3 &&
                                                                                <div className="contacts-action">
                                                                                    <div
                                                                                        className="send_query_list_button send-query btn btn-danger"
                                                                                        onClick={() => {
                                                                                            // sendPricing(CustomerQuoteDetailData?.id)
                                                                                            // navigate("/flexichain/query-list", { state: { quotationId: 3 } });
                                                                                            handleShowPricing()
                                                                                        }}
                                                                                    >

                                                                                        Send for Pricing
                                                                                    </div>



                                                                                </div>
                                                                            }
                                                                            {
                                                                                <div className="contacts-action">
                                                                                    <div
                                                                                        onClick={handleShowRemark}
                                                                                        className="send_query_list_button send-query btn btn-danger"
                                                                                    >
                                                                                        View Remark
                                                                                    </div>
                                                                                </div>

                                                                            }
                                                                        </div>
                                            }
                                        </div> */}

                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-end align-items-center flex-wrap gap-3">
                                                {/* {(buttonConfig[CustomerQuoteDetailData?.quote_status?.name] || buttonConfig["Default"]).map((button, index) => {
                                                    if (button.condition === false) return null; // Skip buttons with a false condition
                                                    return (
                                                        <div key={index} className="contacts-action">
                                                            <div className={button.className} onClick={button.onClick}>
                                                                {button.text}
                                                            </div>
                                                        </div>
                                                    );
                                                })} */}
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="card mb-2">
                                    <div className="card-body pb-2">
                                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                                            <div className="d-lg-flex align-items-start mb-2 w-100 justify-content-between">

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Name </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{CustomerQuoteDetailData?.full_name} ({CustomerQuoteDetailData?.quotation_user_type})</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Email </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{CustomerQuoteDetailData?.email}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Mobile </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{CustomerQuoteDetailData?.phone}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Created At </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{DDMMMYYYYformateDate(CustomerQuoteDetailData?.createdAt)}</p>
                                                        {/* </div> */}
                                                    </div>

                                                </div>

                                                <div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Request No </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{CustomerQuoteDetailData?.request_no}</p>
                                                        {/* </div> */}
                                                    </div>
                                                    <div className="d-flex justify-content-start gap-2 py-1">
                                                        <p className="font-medium">Status </p>
                                                        {/* <div className="box-query"> */}
                                                        <p className="mb-0 text-sm">{CustomerQuoteDetailData?.quote_status?.name}</p>
                                                        {/* </div> */}
                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                {/* /Contact User */}
                            </div>
                            <div className="col-xl-12">
                                <div className="card mb-2">
                                    <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    href="#"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activities"
                                                    className="nav-link active"
                                                >
                                                    <i className="ti ti-alarm-minus me-1" />
                                                    Pickup Information
                                                </a>
                                            </li>


                                        </ul>
                                    </div>
                                </div>
                                {/* Tab Content */}
                                <div className="tab-content pt-0">
                                    {/* Activities */}
                                    <div className="tab-pane active show" id="activities">
                                        <div className="card">

                                            <div className="card-body">
                                                <div className="pb-4 px-md-0 px-3 view-info-box">

                                                    <div className="row">
                                                        <div className=" col-md-6 py-2">

                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Origin </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">
                                                                    {CustomerQuoteDetailData?.origin_type == "AIRPORT" ?
                                                                        `Delhi, India (${CustomerQuoteDetailData?.origin_type})` :
                                                                        `${CustomerQuoteDetailData?.origin_address}, ${CustomerQuoteDetailData?.origin_city ? CustomerQuoteDetailData?.origin_city?.name : ""}, ${CustomerQuoteDetailData?.origin_state ? CustomerQuoteDetailData?.origin_state?.name : ""}, ${CustomerQuoteDetailData?.origin_country ? CustomerQuoteDetailData?.origin_country?.name : ""} (${CustomerQuoteDetailData?.origin_type})`}
                                                                </p>
                                                                {/* </div> */}
                                                            </div>
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Destination</p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{CustomerQuoteDetailData?.destination_type == "AIRPORT" ?
                                                                    `Mumbai, India (${CustomerQuoteDetailData?.destination_type})` :
                                                                    `${CustomerQuoteDetailData?.destination_address}, ${CustomerQuoteDetailData?.destination_city ? CustomerQuoteDetailData?.destination_city?.name : ""}, ${CustomerQuoteDetailData?.destination_state ? CustomerQuoteDetailData?.destination_state?.name : ""}, ${CustomerQuoteDetailData?.destination_country ? CustomerQuoteDetailData?.destination_country?.name : ""} (${CustomerQuoteDetailData?.destination_type})`}</p>
                                                                {/* </div> */}
                                                            </div>
                                                            {CustomerQuoteDetailData?.shipment_mode !== "courier" && <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Incoterm</p>

                                                                <p className="mb-0 text-sm">{CustomerQuoteDetailData?.incoterm ? CustomerQuoteDetailData?.incoterm?.name : <i>N/A</i>}</p>

                                                            </div>}



                                                        </div>
                                                        <div className=" col-md-6 py-2">
                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Shipment Mode </p>
                                                                {/* <div className="box-query"> */}
                                                                <p className="mb-0 text-sm">{CustomerQuoteDetailData?.shipment_mode ? capitalizeFirstLetter(CustomerQuoteDetailData?.shipment_mode) : ""}</p>
                                                                {/* </div> */}
                                                            </div>


                                                            <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Cargo Ready Date </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{DDMMMYYYYformateDate(CustomerQuoteDetailData?.cargo_ready_date)}</p>
                                                                {/* </div> */}
                                                            </div>

                                                            {CustomerQuoteDetailData && CustomerQuoteDetailData?.shipment_mode !== "air" && CustomerQuoteDetailData?.shipment_mode !== "courier" ? <div className="d-flex justify-content-start gap-2 py-2">
                                                                <p className="font-medium">Load Type </p>
                                                                {/* <div className="box-query"> */}

                                                                <p className="mb-0 text-sm">{CustomerQuoteDetailData?.load_type}</p>
                                                                {/* </div> */}
                                                            </div> : ""}
                                                        </div>
                                                        <div className="col-12 py-2">
                                                            <div className=" py-2">
                                                                <div className=" d-sm-flex mb-2 align-items-center">
                                                                    <p className="font-medium ">Additionals
                                                                    </p>

                                                                </div>

                                                                <div className="row">
                                                                    {additionalsArray.map((val, _i) => {
                                                                        return (
                                                                            <div className="col-md-3" key={_i + 1}>
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        className="form-check-input form-switch-add"
                                                                                        type="checkbox"
                                                                                        role="switch"
                                                                                        id={`flexSwitchCheckDefault${_i}`}
                                                                                        value={val?.value}
                                                                                        checked={val.included}
                                                                                        disabled
                                                                                        style={{ opacity: 1 }}
                                                                                    />
                                                                                    <label
                                                                                        className="form-check-label"
                                                                                        htmlFor={`flexSwitchCheckDefault${_i}`}
                                                                                    >
                                                                                        {val.name}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}


                                                                </div>
                                                            </div>

                                                        </div>



                                                        {
                                                            CustomerQuoteDetailData?.shipment_mode !== 'air' && CustomerQuoteDetailData?.load_type == "FULL" ?
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Cargo Details</p>
                                                                    <div className="table-responsive">

                                                                        <table className="posts-table mb-0  table table-bordered view-info-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col"> Quantity</th>
                                                                                    <th scope="col">Container Size</th>
                                                                                    <th scope="col">Container Type</th>
                                                                                    <th scope="col">Unit Weight</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>{CustomerQuoteDetailData?.fl_quantity ?? "N/A"}</td>
                                                                                    <td> {CustomerQuoteDetailData?.containersize ? CustomerQuoteDetailData?.containersize?.name : "N/A"}</td>
                                                                                    <td> {CustomerQuoteDetailData?.containertype ? CustomerQuoteDetailData?.containertype?.name : "N/A"}</td>
                                                                                    <td> {CustomerQuoteDetailData?.fl_weight} {CustomerQuoteDetailData?.fl_weight_unit_id ?? "N/A"}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col-12 py-2 ">
                                                                    <p className="font-medium mb-3">Package Dimensions/Weight</p>
                                                                    <div className="table-responsive">
                                                                        <table className="posts-table mb-0  view-info-table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="p-0">
                                                                                        <tr>
                                                                                            {CustomerQuoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Volume
                                                                                                </td>
                                                                                                : <><td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                    Length
                                                                                                </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Width
                                                                                                    </td>
                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                        Height
                                                                                                    </td></>}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Package Type
                                                                                            </td>
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Approx Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight
                                                                                            </td>
                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Gross Weight Unit
                                                                                            </td> */}
                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                Total Box
                                                                                            </td>
                                                                                        </tr>
                                                                                        {
                                                                                            CustomerQuoteDetailData?.package_info ? (
                                                                                                (CustomerQuoteDetailData?.package_info).map((value, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            {
                                                                                                                CustomerQuoteDetailData?.package_volume_type === "VOLUME" ?

                                                                                                                    <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                        {value?.volume ? `${value?.volume} ${value?.volumeunit}` : 'N/A'}
                                                                                                                    </td> :

                                                                                                                    <>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.length ? `${value?.length} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.width ? `${value?.width} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                        <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                            {value?.height ? `${value?.height} ${value?.dimensionunit}` : 'N/A'}
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                            }

                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.package_type ? value?.package_type?.name : 'N/A'}
                                                                                                            </td>
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.max_weight ? `${value?.max_weight} ${value?.max_weight_unit}` : 'N/A'}
                                                                                                            </td>
                                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td> */}
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight ? `${value?.gross_weight} ${value?.gross_weight_unit}` : 'N/A'}
                                                                                                            </td>
                                                                                                            {/* <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.gross_weight_unit?.name || 'N/A'}
                                                                                                            </td> */}
                                                                                                            <td style={{ border: "1px solid #c7c7c7" }}>
                                                                                                                {value?.total_boxes || 'N/A'}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })
                                                                                            ) : (
                                                                                                <tr>
                                                                                                    <td colSpan="9" style={{ border: "1px solid #c7c7c7", textAlign: "center" }}>
                                                                                                        No data available
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        }
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                        }

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* /Tab Content */}


                                {/* Quotation Information */}
                                <div className="card mb-2">
                                    <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <a
                                                    href="#"
                                                    data-bs-toggle="tab"
                                                    data-bs-target="#activities"
                                                    className="nav-link active"
                                                >
                                                    <i className="fa-solid fa-money-bill-trend-up me-1"></i>
                                                    Quotation Information
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                                {/* Quotation Data */}
                                {
                                    CustomerQuoteDetailData?.quotationData ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="input_box_section ">
                                                        <label>Quotation Number </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={ship_quotation_no}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('shipment_info.quotation_number', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="shipment_info.quotation_number"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section por_main_detail">
                                                        <label>Date of Creation </label>
                                                        <div className="custom-datepicker">
                                                            <DatePicker
                                                                disabled={true}
                                                                selected={ship_date_of_creation}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                        <span>
                                                            <img src="/img/simple-calende.png" alt="Calendar" />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section ">
                                                        <label>Buying Reference Number</label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={ship_buy_ref_no}
                                                            // value={formik.values.shipment_info.buy_ref_number}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="shipment_info.buy_ref_number"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section por_main_detail">
                                                        <label>Rate Validity <span>*</span> </label>

                                                        <div className="custom-datepicker">
                                                            <DatePicker
                                                                disabled={true}
                                                                // selected={rateValidity}
                                                                selected={ship_rate_validity}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>

                                                        <span>
                                                            <img src="/img/simple-calende.png" alt="Calendar" />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section ">
                                                        <label>Quotation Currency</label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={ship_validity_against}
                                                            // value={formik.values.shipment_info.validity_against}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="shipment_info.validity_against"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section ">
                                                        <label>Quotation Rise in <span>*</span></label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={ship_quotation_rise_in}
                                                            // value={formik.values.shipment_info.quotation_rise_in}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="shipment_info.quotation_rise_in"

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Company Name <span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_company_name}
                                                            // value={formik.values.company_info.company_name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.company_name"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Address <span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            value={com_address}
                                                            className="form-control form-control-sm"
                                                            // value={formik.values.company_info.address}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.address"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Phone Number<span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_phone_no}
                                                            // value={formik.values.company_info.phone_number}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.phone_number"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Email ID <span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_email}
                                                            // value={formik.values.company_info.email}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.email"
                                                        // /
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>GSTIN <span></span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_gstin}
                                                            // value={formik.values.company_info.gstin}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.gstin"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section">
                                                        <label>Country <span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_country_id}
                                                            // value={formik.values.company_info.country}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.country"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="input_box_section">
                                                        <label>State <span>*</span> </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={com_state_id}
                                                            // value={formik.values.company_info.state}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="company_info.state"

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Attention To</label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={gen_attention_to}
                                                            // value={formik.values.general_info.attention_to}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.attention_to"

                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-6">
                                            <div className="input_box_section">
                                                <label>Airline </label>
                                                <input
                                                    disabled={true}
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={gen_airline}
                                                    // value={formik.values.general_info.airline}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="general_info.airline"

                                                />
                                            </div>
                                        </div> */}
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Place of Receipt </label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_place_of_receipt}
                                                            // value={formik.values.general_info.place_of_receipt}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.place_of_receipt"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Commodity </label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_commodity}
                                                            // value={formik.values.general_info.commodity}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.commodity"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>{shipmentMode !== "ocean" ? "Air" : ""} Port of Loading <span>*</span> </label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_airport_of_landing}
                                                            // value={formik.values.general_info.airport_of_loading}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.airport_of_loading"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Cargo Weight ({gen_cargo_weight_unit}) </label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_cargo_weight}
                                                            // value={formik.values.general_info.cargo_weight}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.cargo_weight"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>{shipmentMode !== "ocean" ? "Air" : ""} Port of Discharge <span>*</span> </label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_airport_of_discharge}
                                                            // value={formik.values.general_info.airport_of_discharge}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.airport_of_discharge"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Incoterms</label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_incoterms}
                                                            // value={formik.values.general_info.incoterms}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.incoterms"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Tentative Transit Time (In Days) <span>*</span></label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_tentative_transit_time}
                                                            // value={addTimeAndFormat(gen_tentative_transit_time, 0, 0)}
                                                            // value={formik.values.general_info.tentative_transit_time}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.tentative_transit_time"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section">
                                                        <label>Final Place of Delivery <span>*</span></label>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control form-control-sm"
                                                            value={gen_find_place_of_delivery}
                                                            // value={formik.values.general_info.final_delivery_place}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.final_delivery_place"

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input_box_section ">
                                                        <label>Notes</label>
                                                        <textarea
                                                            disabled={true}
                                                            rows={3}
                                                            className="form-control"
                                                            placeholder="Examples..."
                                                            defaultValue={""}
                                                            value={gen_notes}
                                                            // value={formik.values.general_info.notes}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="general_info.notes"

                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {formatted_quote_tarrif && formatted_quote_tarrif.length > 0 ?
                                                formatted_quote_tarrif.map((value, i) => {
                                                    return <div className="users-table border-redi mt-1" key={i + 1}>
                                                        <div className="table_detail_tariff table-wrapper table-responsive" >
                                                            <table key={value[0]?.airline_code} className="posts-table geeks w-100">
                                                                <thead>
                                                                    <tr className="users-table-admin-th">

                                                                        <th>{shipmentMode == "ocean" ? "Ship" : "Air"} line code & Name</th>
                                                                        <th>Charge Head</th>
                                                                        <th>Selling Price</th>
                                                                        <th>Narration</th>
                                                                        <th>Valid Upto</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {value.map((val, index_i) => {
                                                                        const currentEditId = `${i}-${index_i}`;
                                                                        return <tr className="main_table_row_new" key={index_i + 1}>
                                                                            <td>{val.airline_code}</td>
                                                                            <td>{val.charge_head}</td>
                                                                            <td>{val.selling_price}</td>
                                                                            <td>{val.narration}</td>
                                                                            <td>{formatDate(val.valid_upto)}</td>

                                                                        </tr>
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                })
                                                :
                                                <div>
                                                    <div className="text-center"><i>No tarrif data found.</i></div>
                                                </div>
                                            }
                                        </>

                                        :
                                        <div className="text-center">
                                            <i>Quotation information not found.</i>
                                        </div>
                                }
                            </div>


                        </div>

                }
            </div>
        </div>
    )
}

export default CustomerQueryInformation